import { useRef } from 'react';
import { useMutation } from 'react-query';

import { Config } from '@nw/shared/config';
import {
  getAPIErrorMessage,
  getSessionStorageToken,
  setSessionStorageToken
} from '@nw/shared/utils';

const CommonDataInstituteURL = `${Config.COMMON_DATA_INSTITUTE_BASE_URL}`;

const fetchInstituteData = (signal, searchValue) => {
  return fetch(CommonDataInstituteURL, {
    signal,
    method: 'POST',
    body: JSON.stringify({
      data: JSON.stringify(
        JSON.stringify({
          search_value: searchValue,
          offset: 0,
          limit: 100
        })
      ),
      clientKeyDetailsId: 1
    }),
    headers: { 'content-type': 'application/json' }
  }).then((res) => res.json());
};

export const useGetInstitutesMutation = () => {
  const activeRequests = useRef([]); // Ref to store active AbortControllers

  const getInstitutes = async (params) => {
    // Cancel all previous requests
    activeRequests.current.forEach((controller) => controller.abort());
    activeRequests.current = [];

    const abortController = new AbortController();
    activeRequests.current.push(abortController);


    try {
      const textToSearch = params.filterText.trim();
      const key: string = textToSearch.toLocaleLowerCase();
      const sessionStorageKey: string = `institutesName-${key}`;

      const storedResponse = getSessionStorageToken(sessionStorageKey);
      if (storedResponse) return JSON.parse(storedResponse);

      const signal = abortController.signal;
      const data = await fetchInstituteData(signal, textToSearch);
      setSessionStorageToken(sessionStorageKey, data);

      return data;
    } catch (error) {}
  };

  const { mutateAsync, error, status } = useMutation(getInstitutes);

  const getInstitutesApi = (params) => {
    return mutateAsync(params);
  };

  return {
    getInstitutesApi,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
};
